// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"9d00f906617e8854","4439":"8783c8664e7651d2","5801":"6bc154694bf87a84","7744":"be0ff6cf3b098cf6","7746":"e86274eb028c1eb3","9591":"0f20b3ca6073f4b6","9860":"67bef55b6821a9cb"}[chunkId] + ".1779880258576.js";
};